import emailjs from '@emailjs/browser';

export async function sendRequestEmail(payload) {
  const {
    request_type,
    user_name,
    description,
    contact_email,
    contact_phone,
    recipient,
  } = payload;

  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  if (!serviceId || !templateId || !publicKey) {
    throw new Error(
      'Email service is not configured. Set REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, REACT_APP_EMAILJS_PUBLIC_KEY.'
    );
  }

  const templateParams = {
    to_email: recipient,
    request_type,
    user_name,
    description,
    contact_email: contact_email || 'N/A',
    contact_phone: contact_phone || 'N/A',
  };

  try {
    const res = await emailjs.send(serviceId, templateId, templateParams, { publicKey });
    return res;
  } catch (e) {
    const msg = e?.text || e?.message || 'Failed to send email';
    throw new Error(msg);
  }
}
